(()=>{'use strict';
 const mobile=matchMedia('(max-width:760px),(max-width:1023px) and (pointer:coarse)');
 const reduced=matchMedia('(prefers-reduced-motion:reduce)');
 const fine=matchMedia('(hover:hover) and (pointer:fine)');
 // One same-page entry belongs to the whole mobile sheet, not to each tab.
 const createPanelHistory=onTraversal=>{
  const key='__uraMobileNavigation',baseKey='__uraMobileNavigationBase';
  const owner=Date.now().toString(36)+Math.random().toString(36).slice(2);
  const supported=/^https?:$/.test(location.protocol)&&typeof history.pushState==='function';
  const stateObject=()=>history.state&&typeof history.state==='object'&&!Array.isArray(history.state)?{...history.state}:{};
  const marker=()=>stateObject()[key];
  const owned=()=>marker()?.owner===owner;
  let active=null,pending=null,queued=null,queuedNavigation=null,sequence=0;
  const retire=()=>{
   if(owned()){const next=stateObject();delete next[key];history.replaceState(next,'',location.href);}
   active=null;pending=null;queued=null;queuedNavigation=null;
  };
  // A reload must not inherit an orphan modal from an earlier document.
  if(supported&&marker()){const next=stateObject();delete next[key];history.replaceState(next,'',location.href);}
  const rememberUrl=()=>{if(!owned())return;if(active)active.href=location.href;if(pending)pending.href=location.href;};
  const update=kind=>{
   if(!owned())return;
   const next=stateObject();next[key]={...next[key],panel:kind};history.replaceState(next,'',location.href);rememberUrl();
  };
  const enter=(kind,resume)=>{
   if(!supported)return true;
   if(pending){queued=resume;return false;}
   if(owned()){update(kind);return true;}
   const token=owner+':'+(++sequence),next=stateObject();
   next[baseKey]={owner,token};history.replaceState(next,'',location.href);
   history.pushState({...next,[key]:{owner,token,panel:kind}},'',location.href);
   active={token,href:location.href};return true;
  };
  const consume=(restore=false)=>{
   if(!supported||pending||!owned())return;
   pending={token:marker().token,href:location.href,restore};
   try{history.back();}catch(error){pending=null;retire();}
  };
  const traverse=()=>{
   const previous=pending||active,destination=stateObject(),next=destination[key];
   const returnedToBase=!!previous&&destination[baseKey]?.owner===owner&&destination[baseKey]?.token===previous.token&&!next;
   // Fit can change the selected variant inside the sheet. Keep that selection.
   if(returnedToBase&&previous.href!==location.href)history.replaceState(destination,'',previous.href);
   const resume=returnedToBase?queued:null,navigate=returnedToBase?queuedNavigation:null;pending=null;queued=null;queuedNavigation=null;active=null;
   if(next?.owner===owner){active={token:next.token,href:location.href};onTraversal(next.panel);}
   else if(previous)onTraversal(null,previous.restore!==false);
   if(navigate){retire();navigate();}else if(resume)resume();
  };
  if(supported){
   addEventListener('popstate',traverse,true);
   addEventListener('ura:location-updated',rememberUrl);
   addEventListener('ura:catalog-navigation',event=>{
    if((!owned()&&!pending)||typeof event.detail?.commit!=='function')return;
    event.preventDefault();queued=null;
    if(pending){queuedNavigation=event.detail.commit;return;}
    retire();onTraversal(null,false);event.detail.commit();
   });
   addEventListener('pagehide',retire);
  }
  return {enter,update,consume,retire,owned};
 };
 function init(){
  const sheet=document.querySelector('[data-ura-mobile-nav]'),dock=document.querySelector('[data-ura-app-dock-final]');
  if(!sheet||!dock||sheet.dataset.mobileNavReady)return;
  const unit=sheet.querySelector('[data-mnav-unit]');
  const surface=sheet.querySelector('[data-mnav-surface]'),scroll=sheet.querySelector('.ura-mnav__scroll'),bagHost=sheet.querySelector('[data-mnav-bag-host]');
  if(!surface||!bagHost)return;
  sheet.dataset.mobileNavReady='true';
  const inputMode=mode=>{sheet.dataset.mnavInput=mode;dock.dataset.mnavInput=mode;};
  document.addEventListener('pointerdown',()=>inputMode('pointer'),{capture:true,passive:true});
  document.addEventListener('keydown',event=>{if(!event.metaKey&&!event.ctrlKey&&!event.altKey)inputMode('keyboard');},true);
  const home=document.createComment('URA dock');dock.before(home);
  const cart=document.getElementById('UraCartDrawer'),cartPanel=cart?.querySelector('.ura-cart-drawer__panel');
  const cartHome=document.createComment('URA bag');if(cart)cart.before(cartHome);
  const nativeBag=document.querySelector('#UraHeader .ura-header__inner [data-ura-bag-v2]');
  const actions=[...dock.querySelectorAll('[data-app-action]')],tabs=[...sheet.querySelectorAll('[data-mnav-tab]')],views=[...sheet.querySelectorAll('[data-mnav-view]')];
  const input=sheet.querySelector('[data-ura-predictive-input]'),head=sheet.querySelector('.ura-mnav__head'),tablist=sheet.querySelector('[data-mnav-tabs]'),footer=sheet.querySelector('.ura-mnav__footer');
  const searchField=sheet.querySelector('.ura-mnav__search-field'),searchHost=sheet.querySelector('[data-mnav-search-dock]');
  const searchHome=document.createComment('URA search');searchField?.before(searchHome);
  const restoreSearch=()=>{if(searchField&&searchHome.parentNode&&searchField.parentNode!==searchHome.parentNode)searchHome.after(searchField);};
  const accountEntry=sheet.querySelector('[data-mnav-open-account]');
  const account=sheet.querySelector('[data-ura-mobile-panel-account]'),sizeRoom=document.querySelector('[data-ura-size-room]');
  let inlineFit=document.querySelector('[data-ura-fit-integrated][data-ura-fit-inline]');
  const fitView=sheet.querySelector('[data-mnav-fit-view]'),fitHost=sheet.querySelector('[data-mnav-fit-product-host]'),fitFallback=sheet.querySelector('[data-mnav-fit-fallback]');
  let fitOwner=inlineFit?.closest('[data-ura4-product]');
  let fitHome=null,fitPlaceholder=null,fitPortalActive=false,fitWasOpen=false;
  const scrollPositions=new Map();let pagePosition=null;
  let panel='shop',shopPanel='shop',state='closed',opener=null,previousOverflow='',lockOwned=false,previewNode=null,resizeFrame=0,glassFrame=0,glassWidth=0,glassSnapFrame=0,motion=null,contentMotion=null,motionVersion=0,viewportReleaseFrame=0,lastModalHeight=0,lastModalTop=0,keyboardViewport=false,fitRequested=false,fitSeen=false;
  const cartOpen=()=>cart?.getAttribute('aria-hidden')==='false';
  const accountOpen=()=>account?.getAttribute('data-ura-account-open')==='true';
  let nativeHistoryClose=false;
  const panelHistory=createPanelHistory((kind,restore)=>{
   resetFitRequest();
   if(kind&&mobile.matches){open(kind,null,false);return;}
   if(accountOpen())nativeHistoryClose=true;
   else close(restore,true,'traverse');
   queueViewport();
  });
  const mode=()=>panel==='explore'?'shop':panel;
  const routeActive=()=>{
   const path=location.pathname.replace(/\/+$/,'')||'/';
   if(/\/pages\/(?:ura-)?perfect-fit$/.test(path))return 'fit';
   if(/\/(?:account|customer_authentication)(?:\/|$)/.test(path))return 'account';
   if(/\/cart(?:\/|$)/.test(path))return 'bag';
   if(/\/search(?:\/|$)/.test(path))return 'search';
   if(/\/(?:collections|products)(?:\/|$)/.test(path)||path===(dock.dataset.root||'/').replace(/\/+$/,'')||path==='/')return 'shop';
   return '';
  };
  const fitVisible=()=>{
   if(!inlineFit?.getClientRects().length)return false;
   const r=inlineFit.getBoundingClientRect(),h=window.visualViewport?.height||innerHeight,t=window.visualViewport?.offsetTop||0;
   return r.top<t+h*.6&&r.bottom>t+Math.min(160,h*.35);
  };
  const fitOpen=()=>!!sizeRoom?.open&&!!sizeRoom.querySelector('[data-ura-room-tab="fit"][aria-selected="true"]');
  const glass={x:0,width:0,targetX:0,targetWidth:0,vx:0,vw:0,frame:0,time:0,ready:false,limit:0,direction:''};
  const glassEnabled=()=>dock.dataset.uraDockLanguage!=='unit';
  const stopGlass=()=>{
   cancelAnimationFrame(glassFrame);cancelAnimationFrame(glass.frame);
   glassFrame=0;glass.frame=0;glass.time=0;glass.vx=glass.vw=0;glass.ready=false;
   dock.removeAttribute('data-glass-ready');dock.removeAttribute('data-glass-motion');
  };
  const paintGlass=()=>{
   const stretch=reduced.matches?0:Math.min(6,Math.abs(glass.vx)*.01);
   const width=Math.min(glass.limit,Math.max(0,glass.width+stretch));
   const x=Math.max(0,Math.min(glass.limit-width,glass.x-stretch/2));
   dock.style.setProperty('--ura-dock-selection-x',x.toFixed(3)+'px');
   dock.style.setProperty('--ura-dock-selection-width',width.toFixed(3)+'px');
  };
  const settleGlass=()=>{
   if(!glassEnabled()){stopGlass();return;}
   cancelAnimationFrame(glass.frame);glass.frame=0;glass.time=0;
   glass.x=glass.targetX;glass.width=glass.targetWidth;glass.vx=glass.vw=0;
   dock.dataset.glassMotion='settled';paintGlass();
  };
  const stepGlass=now=>{
   glass.frame=0;
   if(!glassEnabled()){stopGlass();return;}
   if(!dock.isConnected||!mobile.matches||document.hidden||reduced.matches||!dock.hasAttribute('data-glass-ready')){settleGlass();return;}
   let remaining=glass.time?Math.min((now-glass.time)/1000,.032):1/60;glass.time=now;
   while(remaining>0){const dt=Math.min(remaining,.008);remaining-=dt;
    glass.vx+=(520*(glass.targetX-glass.x)-36*glass.vx)*dt;glass.x+=glass.vx*dt;
    glass.vw+=(520*(glass.targetWidth-glass.width)-36*glass.vw)*dt;glass.width+=glass.vw*dt;
   }
   if(Math.abs(glass.targetX-glass.x)<.025&&Math.abs(glass.targetWidth-glass.width)<.025&&Math.abs(glass.vx)<.08&&Math.abs(glass.vw)<.08){settleGlass();return;}
   dock.dataset.glassMotion='moving';paintGlass();glass.frame=requestAnimationFrame(stepGlass);
  };
  const measureGlass=()=>{
   glassFrame=0;
   if(!glassEnabled()){stopGlass();return;}
   const active=actions.find(action=>action.hasAttribute('data-active'));
   if(!mobile.matches||!active||!dock.getClientRects().length){dock.removeAttribute('data-glass-ready');glass.ready=false;settleGlass();return;}
   const outer=dock.getBoundingClientRect(),rect=active.getBoundingClientRect(),direction=getComputedStyle(dock).direction;
   if(rect.width<1){dock.removeAttribute('data-glass-ready');glass.ready=false;settleGlass();return;}
   const snap=!glass.ready||Math.abs(outer.width-glassWidth)>.5||direction!==glass.direction||reduced.matches;
   glassWidth=outer.width;glass.limit=dock.clientWidth;glass.direction=direction;
   glass.targetX=rect.left-outer.left-dock.clientLeft;glass.targetWidth=rect.width;glass.ready=true;
   dock.dataset.glassShape=active.dataset.appAction;dock.setAttribute('data-glass-ready','');
   if(snap)settleGlass();else if(!glass.frame){glass.time=0;glass.frame=requestAnimationFrame(stepGlass);}
  };
  const queueGlass=()=>{if(!glassEnabled()){stopGlass();return;}if(!glassFrame)glassFrame=requestAnimationFrame(measureGlass);};
  let pressedDockAction=null,pressedDockPointer=null;
  const clearDockPress=()=>{
   if(!pressedDockAction)return;
   pressedDockAction.removeAttribute('data-dock-pressed');
   pressedDockAction.style.removeProperty('--ura-dock-magnet-x');pressedDockAction.style.removeProperty('--ura-dock-magnet-y');
   pressedDockAction=null;pressedDockPointer=null;
  };
  const magnetDock=(action,event)=>{
   if(reduced.matches)return;
   const rect=action.getBoundingClientRect();
   const x=Math.max(-2.5,Math.min(2.5,(event.clientX-rect.left-rect.width/2)*.09));
   const y=Math.max(-2,Math.min(2,(event.clientY-rect.top-rect.height/2)*.09));
   action.style.setProperty('--ura-dock-magnet-x',x.toFixed(2)+'px');action.style.setProperty('--ura-dock-magnet-y',y.toFixed(2)+'px');
  };
  actions.forEach(action=>{
   action.addEventListener('pointerdown',event=>{if(event.button!==0||reduced.matches)return;clearDockPress();pressedDockAction=action;pressedDockPointer=event.pointerId;action.setAttribute('data-dock-pressed','');magnetDock(action,event);},{passive:true});
   action.addEventListener('pointermove',event=>{if(pressedDockAction===action&&pressedDockPointer===event.pointerId)magnetDock(action,event);},{passive:true});
   action.addEventListener('pointerleave',()=>{if(pressedDockAction===action)clearDockPress();});
  });
  ['pointerup','pointercancel'].forEach(type=>document.addEventListener(type,clearDockPress,{passive:true}));
  addEventListener('blur',clearDockPress);
  document.addEventListener('visibilitychange',()=>{if(document.hidden){clearDockPress();settleGlass();}else queueGlass();});
  reduced.addEventListener('change',()=>{clearDockPress();if(reduced.matches)settleGlass();queueGlass();});
  const syncDock=()=>{
   if(fitRequested&&fitVisible())fitSeen=true;
   const overlay=sheet.open||cartOpen()||!!sizeRoom?.open,route=routeActive();
   const selected=accountOpen()?'account':sheet.open?mode():cartOpen()?'bag':fitOpen()?'fit':fitRequested?'fit':route;
   actions.forEach(action=>{
    const kind=action.dataset.appAction,active=kind===selected;
    action.toggleAttribute('data-active',active);
    if(active&&!overlay)action.setAttribute('aria-current',kind===route?'page':'location');else action.removeAttribute('aria-current');
    if(['shop','search','account','bag'].includes(kind)||kind==='fit'&&fitView){
     action.setAttribute('aria-controls',sheet.id);action.setAttribute('aria-haspopup','dialog');action.setAttribute('aria-expanded',String(sheet.open&&kind===mode()));
    }
    if(kind==='fit'&&!fitView&&sizeRoom&&!inlineFit){action.setAttribute('aria-haspopup','dialog');action.setAttribute('aria-controls',sizeRoom.id);action.setAttribute('aria-expanded',String(fitOpen()));}
   });
   queueGlass();
  };
  const restoreDock=()=>{if(home.parentNode&&dock.parentNode!==home.parentNode)home.after(dock);queueGlass();};
  const restoreCart=()=>{
   if(!cart)return;
   if(cartHome.parentNode&&cart.parentNode!==cartHome.parentNode)cartHome.after(cart);
   cartPanel?.setAttribute('role','dialog');cartPanel?.setAttribute('aria-modal','true');cart.removeAttribute('data-ura-mobile-hosted');
  };
  const closeCart=()=>{if(cartOpen())window.URACartDrawer?.close(false);};
  const mountCart=()=>{if(!cart)return;bagHost.append(cart);cart.setAttribute('data-ura-mobile-hosted','');cartPanel?.setAttribute('role','group');cartPanel?.removeAttribute('aria-modal');};
  const demoActive=active=>{if(fitView)window.URAMobileFitDemo?.setActive(fitView,active);};
  const restoreFit=()=>{
   demoActive(false);
   if(!fitPortalActive)return;
   fitPortalActive=false;
   inlineFit.removeAttribute('data-ura-mobile-fit-hosted');
   if(fitHome?.parentNode)fitHome.after(inlineFit);else inlineFit.remove();
   fitPlaceholder?.remove();fitPlaceholder=null;fitHome?.remove();fitHome=null;
   if(inlineFit.tagName==='DETAILS')inlineFit.open=fitWasOpen;
  };
  const mountFit=()=>{
   sheet.dataset.fitContext=fitHost?'product':'demo';
   if(!fitHost)return false;
   if(fitPortalActive&&fitOwner?.isConnected&&fitHome?.isConnected&&inlineFit?.isConnected&&fitHost.contains(inlineFit))return true;
   if(fitPortalActive)restoreFit();
   const owner=[...document.querySelectorAll('#MainContent [data-ura4-product]')].find(root=>!fitHost.dataset.mnavFitProductHandle||root.getAttribute('data-product-handle')===fitHost.dataset.mnavFitProductHandle);
   const candidate=owner?.querySelector('[data-ura-fit-integrated][data-ura-fit-inline]');
   if(!candidate||!owner?.isConnected||owner.getAttribute('data-ura4-ready')!=='true')return false;
   inlineFit=candidate;fitOwner=owner;
   const rect=inlineFit.getBoundingClientRect(),style=getComputedStyle(inlineFit);
   fitHome=document.createComment('URA inline Fit');inlineFit.before(fitHome);
   fitPlaceholder=document.createElement('div');fitPlaceholder.setAttribute('data-ura-fit-placeholder','');fitPlaceholder.setAttribute('aria-hidden','true');fitPlaceholder.inert=true;
   Object.assign(fitPlaceholder.style,{height:Math.max(0,rect.height)+'px',width:rect.width>0?rect.width+'px':'100%',maxWidth:'100%',margin:style.margin,order:style.order,flex:style.flex,gridColumn:style.gridColumn,boxSizing:'border-box',pointerEvents:'none'});
   inlineFit.before(fitPlaceholder);fitWasOpen=!!inlineFit.open;
   fitHost.append(inlineFit);inlineFit.setAttribute('data-ura-mobile-fit-hosted','');
   if(inlineFit.tagName==='DETAILS')inlineFit.open=true;
   fitPortalActive=true;if(fitFallback)fitFallback.hidden=true;
   return true;
  };
  const presented=()=>{if(sheet.open&&state==='open'&&panel==='fit')demoActive(true);};
  const setStyleIfChanged=(node,name,value)=>{if(node.style.getPropertyValue(name)!==value)node.style.setProperty(name,value);};
  let viewportKey="";
  const updateViewport=()=>{
   resizeFrame=0;
   const vv=window.visualViewport,scale=vv?.scale||1,rawHeight=vv?.height||innerHeight;
   const layoutHeight=Math.max(innerHeight,document.documentElement.clientHeight||0);
   if(!mobile.matches||Math.abs(scale-1)>=.05)keyboardViewport=false;
   else if(rawHeight<layoutHeight-140)keyboardViewport=true;
   else if(rawHeight>=layoutHeight-4)keyboardViewport=false;
   const keyboard=keyboardViewport;
   const top=keyboard||Math.abs(scale-1)>=.05?Math.max(0,vv?.offsetTop||0):0;
   let height=rawHeight;
   const preview=document.getElementById('PBarNextFrameWrapper');let previewHeight=0;
   if(preview&&getComputedStyle(preview).display!=='none'){
    const r=preview.getBoundingClientRect();previewHeight=Math.min(100,r.height);if(r.top>top&&r.top<top+height)height=r.top-top;
    if(previewNode!==preview){previewNode=preview;new ResizeObserver(queueViewport).observe(preview);}
   }
   height=Math.max(120,height);
   const nextViewportKey=[Math.round(height*2),Math.round(top*2),previewHeight,keyboard,state,panel,mobile.matches].join(':');
   if(nextViewportKey===viewportKey)return;
   viewportKey=nextViewportKey;
   const geometryChanged=Math.abs(height-lastModalHeight)>.5||Math.abs(top-lastModalTop)>.5;
   if(geometryChanged&&sheet.open){
    sheet.setAttribute('data-mnav-viewport-changing','');
    if(viewportReleaseFrame)cancelAnimationFrame(viewportReleaseFrame);
    viewportReleaseFrame=requestAnimationFrame(()=>{viewportReleaseFrame=0;sheet.removeAttribute('data-mnav-viewport-changing');});
   }
   lastModalHeight=height;lastModalTop=top;
   setStyleIfChanged(sheet,'--ura-mnav-window-height',height+'px');
   setStyleIfChanged(sheet,'--ura-mnav-window-top',top+'px');
   setStyleIfChanged(document.body,'--ura-shop-preview-inset',previewHeight+'px');
   const editing=!!document.activeElement?.matches('input:not([type=radio]):not([type=checkbox]),textarea');
   if(state==='closed'&&!keyboard&&!editing&&Math.abs(scale-1)<.05){
    setStyleIfChanged(document.documentElement,'--ura-mobile-window-height',height+'px');
    setStyleIfChanged(document.documentElement,'--ura-mobile-window-top','0px');
   }
   document.body.toggleAttribute('data-ura-keyboard-open',keyboard);sheet.toggleAttribute('data-mnav-compact',height<300||((panel==='shop'||panel==='explore')&&height<440));syncDock();
  };
  const queueViewport=()=>{if(!resizeFrame)resizeFrame=requestAnimationFrame(updateViewport);};
  const animateSurface=(opening,complete)=>{
   const motionSurface=unit||surface;
   const version=++motionVersion,interrupted=!!motion,style=interrupted?getComputedStyle(motionSurface):null;
   const from=interrupted?{transform:style.transform,opacity:style.opacity}:opening?{transform:'translate3d(0,18px,0)',opacity:0}:{transform:'translate3d(0,0,0)',opacity:1};
   motion?.cancel();motion=null;
   if(reduced.matches||typeof surface.animate!=='function'){complete?.();return;}
   const next=motionSurface.animate([from,opening?{transform:'translate3d(0,0,0)',opacity:1}:{transform:'translate3d(0,12px,0)',opacity:0}],{duration:opening?220:160,easing:opening?'cubic-bezier(.2,.75,.25,1)':'cubic-bezier(.4,0,.7,.3)',fill:'both'});
   motion=next;next.finished.then(()=>{if(version!==motionVersion)return;motion=null;complete?.();next.cancel();}).catch(()=>{});
  };
  const saveScroll=()=>{scrollPositions.set(panel,scroll.scrollTop);};
  const finishClose=restore=>{
   ++motionVersion;motion?.cancel();motion=null;contentMotion?.cancel();contentMotion=null;
   state='closed';sheet.dataset.state=state;saveScroll();sheet.dispatchEvent(new CustomEvent('ura:mobile-panel-change',{detail:{panel:null}}));closeCart();
   if(sheet.open)sheet.close();
   document.body.classList.remove('ura-mnav-open');
   if(lockOwned){document.body.style.overflow=previousOverflow;lockOwned=false;}
   restoreSearch();restoreFit();restoreCart();restoreDock();syncDock();
   if(pagePosition){const saved=pagePosition;pagePosition=null;if(Math.abs(scrollY-saved.y)>1||Math.abs(scrollX-saved.x)>1){const prior=document.documentElement.style.scrollBehavior;document.documentElement.style.scrollBehavior='auto';scrollTo(saved.x,saved.y);document.documentElement.style.scrollBehavior=prior;}}
   if(restore&&opener?.isConnected)opener.focus({preventScroll:true});queueViewport();
  };
  const close=(restore=false,immediate=false,historyMode='consume')=>{
   if(!sheet.open||accountOpen())return;
   if(state==='closing'&&!immediate)return;
   if(historyMode==='consume')panelHistory.consume(restore);
   else if(historyMode==='navigate')panelHistory.retire();
   state='closing';sheet.dataset.state=state;contentMotion?.cancel();contentMotion=null;
   surface.inert=true;
   if(immediate){++motionVersion;motion?.cancel();motion=null;finishClose(restore);}
   else animateSurface(false,()=>finishClose(restore));
  };
  const sizeSearch=()=>sheet.toggleAttribute('data-mnav-search-results',String(input?.value||'').trim().length>=2);
  input?.addEventListener('input',sizeSearch);
  const focusPanel=(focusSearch=false)=>{
   if(panel==='search')(focusSearch?input:searchHost?.querySelector('[data-mnav-close]')||head.querySelector('[data-mnav-close]'))?.focus({preventScroll:true});
   else if(panel==='bag')cartPanel?.focus({preventScroll:true});
   else if(panel==='fit')(fitPortalActive?inlineFit:fitView)?.focus({preventScroll:true});
   else (views.find(view=>view.dataset.mnavView===panel)?.querySelector('[data-mnav-panel-focus]')||head.querySelector('[data-mnav-close]'))?.focus({preventScroll:true});
  };
  const selectPanel=(kind,focus=false)=>{
   const changed=panel!==kind;saveScroll();
   if(kind!=='fit')restoreFit();
   if(searchHost){searchHost.hidden=kind!=='search';if(kind==='search'&&searchField)searchHost.append(searchField);else restoreSearch();}
   accountEntry?.setAttribute('aria-expanded',String(kind==='account'));
   if(kind!=='bag'&&cartOpen())closeCart();
   panel=kind;sheet.dispatchEvent(new CustomEvent('ura:mobile-panel-change',{detail:{panel:kind}}));if(kind==='shop'||kind==='explore')shopPanel=kind;
   panelHistory.update(kind);
   sheet.dataset.panel=kind;if(kind==='search')sizeSearch();head.hidden=kind==='bag';tablist.hidden=kind!=='shop'&&kind!=='explore';scroll.hidden=kind==='bag';bagHost.hidden=kind!=='bag';footer.hidden=kind!=='shop'&&kind!=='explore';
   tabs.forEach(tab=>{const active=tab.dataset.mnavTab===kind;tab.setAttribute('aria-selected',String(active));tab.tabIndex=active?0:-1;});
   views.forEach(view=>{view.hidden=view.dataset.mnavView!==kind;});
   scroll.scrollTop=scrollPositions.get(kind)||0;
   const action=actions.find(action=>action.dataset.appAction===mode());sheet.setAttribute('aria-label',action?.getAttribute('aria-label')||action?.textContent.trim()||'URA');
   contentMotion?.cancel();contentMotion=null;
   if(changed&&sheet.open&&state==='open'&&!reduced.matches&&typeof scroll.animate==='function'){
    const node=kind==='bag'?bagHost:scroll;contentMotion=node.animate([{opacity:.55,transform:'translate3d(0,8px,0)'},{opacity:1,transform:'translate3d(0,0,0)'}],{duration:180,easing:'cubic-bezier(.2,.75,.25,1)'});
   }
   syncDock();if(focus)focusPanel();
  };
  const open=(kind,trigger,focusSearch=false)=>{
   if(!sheet.isConnected||!dock.isConnected||!mobile.matches||accountOpen()||!['shop','explore','search','account','bag','fit'].includes(kind))return;
   if(kind==='account'&&!views.some(view=>view.dataset.mnavView==='account')||kind==='fit'&&!fitView)return;
   if(!panelHistory.enter(kind,()=>open(kind,trigger,focusSearch)))return;
   surface.inert=false;
   const wasOpen=sheet.open,wasClosing=state==='closing',sizeOverflow=sizeRoom?.open?(sizeRoom.dataset.uraPreviousOverflow||''):null;
   if(trigger&&(!wasOpen||trigger.closest('[data-ura-app-dock-final]')))opener=trigger;else if(!wasOpen)opener=document.activeElement;
   if(sizeRoom?.open){sizeRoom.setAttribute('data-ura-mobile-handoff','');sizeRoom.close();}
   document.dispatchEvent(new CustomEvent('ura:navigation-open',{detail:{source:'mobile',panel:kind}}));
   if(kind==='bag')mountCart();
   if(kind==='fit'){mountFit();if(fitFallback)fitFallback.hidden=fitPortalActive;}
   const entering=!wasOpen||wasClosing;
   if(entering){state='opening';sheet.dataset.state=state;}
   selectPanel(kind);
   if(!wasOpen){
    pagePosition={x:scrollX,y:scrollY};previousOverflow=sizeOverflow===null?document.body.style.overflow:sizeOverflow;lockOwned=true;document.body.style.overflow='hidden';document.body.classList.add('ura-mnav-open');
    sheet.querySelector('[data-mnav-dock-host]').append(dock);updateViewport();sheet.showModal();
   }
   if(kind==='bag'&&!cartOpen())window.URACartDrawer?.open();
   updateViewport();
   if(entering)animateSurface(true,()=>{state='open';sheet.dataset.state=state;presented();});else presented();
   focusPanel(focusSearch);
  };
  tabs.forEach((tab,index)=>{
   tab.addEventListener('click',()=>selectPanel(tab.dataset.mnavTab));
   tab.addEventListener('keydown',event=>{
    if(!['ArrowRight','ArrowLeft','Home','End'].includes(event.key))return;
    event.preventDefault();const next=event.key==='Home'?0:event.key==='End'?tabs.length-1:1-index;selectPanel(tabs[next].dataset.mnavTab);tabs[next].focus({preventScroll:true});
   });
  });
  sheet.querySelectorAll('.ura-mnav__disclosure').forEach((disclosure,index)=>{
   const summary=disclosure.querySelector(':scope>summary'),content=disclosure.querySelector(':scope>.ura-mnav__grid');
   if(!summary||!content)return;
   if(!content.id)content.id=sheet.id+'-disclosure-'+index;
   summary.setAttribute('aria-controls',content.id);
   const syncDisclosure=()=>summary.setAttribute('aria-expanded',String(disclosure.open));
   summary.addEventListener('click',event=>{
    if(!mobile.matches||!sheet.open||state!=='open'||panel!=='shop'||event.defaultPrevented||event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
    if(summary.getAttribute('aria-disabled')==='true'){event.preventDefault();return;}
    if(event.target.closest('a,button,input,select,textarea'))return;
    event.preventDefault();
    disclosure.open=!disclosure.open;
    syncDisclosure();
   });
   disclosure.addEventListener('toggle',syncDisclosure);
   syncDisclosure();
  });
  sheet.querySelectorAll('[data-mnav-close]').forEach(button=>button.addEventListener('click',()=>close(true)));
  accountEntry?.addEventListener('click',()=>open('account',accountEntry,false));
  sheet.addEventListener('cancel',event=>{if(accountOpen())return;event.preventDefault();close(true);});
  sheet.addEventListener('keydown',event=>{
   if(accountOpen())return;
   if(event.key==='Escape'){event.preventDefault();event.stopPropagation();close(true);}
  },true);
  sheet.addEventListener('close',()=>{if(!sheet.open&&state!=='closed'){panelHistory.consume();finishClose(false);}});
  sheet.addEventListener('click',event=>{
   if(event.target===sheet){close(true);return;}
   if(event.target.closest('[data-ura-cart-drawer-close]')&&panel==='bag'){event.preventDefault();event.stopImmediatePropagation();close(true);return;}
   const link=event.target.closest('a[href]');
   if(link&&!link.closest('[data-app-action]')&&!link.hasAttribute('download')&&(!link.target||link.target==='_self')&&event.button===0&&!event.metaKey&&!event.ctrlKey&&!event.shiftKey&&!event.altKey)close(false,true,'navigate');
  },true);
  sheet.addEventListener('submit',event=>{if(!event.defaultPrevented&&event.target.matches('[data-ura-predictive-form],.ura-mnav__languages'))close(false,true,'navigate');});
  sheet.addEventListener('click',event=>{
   if(!fitPortalActive||panel!=='fit'||!sheet.open)return;
   const applied=event.target.closest('[data-ura4-fit-apply]'),previous=applied?.closest('[data-ura-system-fit-panel]');
   if(!previous?.hidden)return;
   const next=fitHost.querySelector('[data-ura-system-fit-tab][aria-pressed="true"]');
   if(next){scroll.scrollTop=0;next.focus({preventScroll:true});}
  });
  actions.forEach(action=>action.addEventListener('click',event=>{
   if(!mobile.matches||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
   const kind=action.dataset.appAction;
   if(['shop','search','account'].includes(kind)||kind==='bag'&&window.URACartDrawer||kind==='fit'&&fitView){
    if(kind==='account'&&!views.some(view=>view.dataset.mnavView==='account')||kind==='fit'&&!fitView)return;
    event.preventDefault();event.stopPropagation();
    if(sheet.open&&mode()===kind&&state!=='closing')close(true);else open(kind==='shop'?shopPanel:kind,action,event.detail===0);return;
   }
   if(kind==='fit'){
    const sizeOpen=document.querySelector('[data-ura-size-open]:not([hidden])'),fit=document.querySelector('[data-ura-fit-integrated]');
    if(fit?.hasAttribute('data-ura-fit-inline')){
     event.preventDefault();event.stopPropagation();opener=action;close(false,true);closeCart();document.dispatchEvent(new CustomEvent('ura:navigation-open',{detail:{source:'fit'}}));
     fitRequested=true;fitSeen=false;fit.scrollIntoView({block:'start',behavior:reduced.matches?'auto':'smooth'});fit.focus({preventScroll:true});syncDock();return;
    }
    if(sizeOpen&&fit){
     event.preventDefault();event.stopPropagation();opener=action;close(false,true);closeCart();document.dispatchEvent(new CustomEvent('ura:navigation-open',{detail:{source:'fit'}}));
     sizeOpen.click();const tab=document.querySelector('[data-ura-room-tab="fit"]');tab?.click();tab?.focus({preventScroll:true});syncDock();return;
    }
   }
   fitRequested=false;fitSeen=false;close(false,true,'navigate');closeCart();syncDock();
  }));
  document.querySelectorAll('[data-ura-purchase-nav]').forEach(action=>{
   action.setAttribute('aria-controls',sheet.id);
   action.addEventListener('click',event=>{
    if(!mobile.matches||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
    const kind=action.dataset.uraPurchaseNav;
    if(kind!=='shop'&&!(kind==='bag'&&window.URACartDrawer))return;
    event.preventDefault();open(kind==='shop'?shopPanel:kind,action,true);
   });
  });
  if(account){
   account.addEventListener('keydown',event=>{if(accountOpen()&&(event.key==='Escape'||event.key==='Tab'))event.stopPropagation();});
   account.addEventListener('open',event=>{if(event.target!==account)return;account.setAttribute('data-ura-account-open','true');document.documentElement.classList.add('ura-account-sheet-open');syncDock();});
   account.addEventListener('close',event=>{if(event.target!==account)return;account.removeAttribute('data-ura-account-open');document.documentElement.classList.toggle('ura-account-sheet-open',!!document.querySelector('shopify-account[data-ura-account-open="true"]'));if(nativeHistoryClose){nativeHistoryClose=false;close(false,true,'traverse');}else if(!mobile.matches)close(false,true);syncDock();queueViewport();});
  }
  if(nativeBag){
   const sync=()=>{const qty=Number(nativeBag.dataset.uraBagCount)||0,badge=dock.querySelector('[data-app-count]'),a=actions.find(action=>action.dataset.appAction==='bag');badge.textContent=qty>99?'99+':String(qty);badge.hidden=!qty;a.setAttribute('aria-label',a.dataset.label+(qty?', '+qty:''));};
   sync();new MutationObserver(sync).observe(nativeBag,{attributes:true,attributeFilter:['data-ura-bag-count']});
  }
  if(cart)new MutationObserver(()=>{
   if(!mobile.matches)return;
   if(cartOpen()&&(!sheet.open||panel!=='bag'))open('bag');
   else if(!cartOpen()&&sheet.open&&panel==='bag'&&state!=='closing')close(true);
   syncDock();
  }).observe(cart,{attributes:true,attributeFilter:['aria-hidden']});
  if(sizeRoom)new MutationObserver(()=>{if(sizeRoom.open&&sheet.open)close(false,true);syncDock();}).observe(sizeRoom,{attributes:true,attributeFilter:['open','aria-selected'],subtree:true});
  document.addEventListener('shopify:section:load',()=>{if(fitPortalActive&&(!fitOwner?.isConnected||!fitHome?.isConnected))close(false,true);});
  document.addEventListener('shopify:section:unload',event=>{if(event.target.contains(sheet)||fitPortalActive&&(event.target===fitOwner||event.target.contains(fitOwner)))close(false,true);});
  document.addEventListener('ura:fit-purchase-ready',event=>{if(fitPortalActive&&panel==='fit'&&sheet.open&&event.target===fitOwner)close(false,true);});
  document.addEventListener('ura:mobile-panel-request',event=>open(event.detail?.panel,event.detail?.trigger,event.detail?.focusInput===true));
  document.addEventListener('ura:navigation-open',event=>{if(event.detail?.source!=='mobile'&&event.detail?.source!=='bag')close(false,true);});
  document.addEventListener('click',event=>{if(event.target.closest('[data-ura-size-open],[data-ura4-add]'))close(false,true);});
  const resetFitRequest=()=>{fitRequested=false;fitSeen=false;syncDock();};
  const syncHash=()=>{resetFitRequest();panelHistory.retire();if(sheet.open)close(false,true,'traverse');queueViewport();};
  addEventListener('pageshow',event=>{if(event.persisted&&!panelHistory.owned())close(false,true,'traverse');syncDock();queueViewport();});addEventListener('hashchange',syncHash);
  document.addEventListener('focusin',queueViewport);document.addEventListener('focusout',queueViewport);addEventListener('resize',queueViewport,{passive:true});
  window.visualViewport?.addEventListener('resize',queueViewport,{passive:true});window.visualViewport?.addEventListener('scroll',queueViewport,{passive:true});new MutationObserver(queueViewport).observe(document.body,{childList:true});
  addEventListener('scroll',()=>{if(!fitRequested||sheet.open)return;if(fitSeen&&!fitVisible())resetFitRequest();else queueViewport();},{passive:true});
  ['wheel','touchstart'].forEach(type=>addEventListener(type,()=>{if(fitRequested&&!fitSeen)resetFitRequest();},{passive:true}));
  document.addEventListener('keydown',event=>{if(fitRequested&&!fitSeen&&['Escape','ArrowUp','ArrowDown','PageUp','PageDown','Home','End'].includes(event.key))resetFitRequest();});
  if(inlineFit)new MutationObserver(()=>{if(inlineFit.hasAttribute('hidden')||inlineFit.tagName==='DETAILS'&&!inlineFit.open)resetFitRequest();}).observe(inlineFit,{attributes:true,attributeFilter:['hidden','open']});
  const glassObserver=new ResizeObserver(queueGlass);glassObserver.observe(dock);actions.forEach(action=>glassObserver.observe(action));
  new MutationObserver(queueGlass).observe(document.documentElement,{attributes:true,attributeFilter:['dir','lang']});document.fonts?.ready.then(queueGlass);
  mobile.addEventListener('change',()=>{resetFitRequest();close(false,true);if(!mobile.matches){closeCart();restoreFit();restoreCart();restoreDock();}queueViewport();});
  reduced.addEventListener('change',()=>{if(!reduced.matches)return;++motionVersion;motion?.cancel();motion=null;contentMotion?.cancel();contentMotion=null;if(state==='closing')finishClose(true);else if(state==='opening'){state='open';sheet.dataset.state=state;presented();}});
  syncDock();updateViewport();
 }
 init();document.addEventListener('shopify:section:load',init);
 document.querySelectorAll('.ura-mnav__languages,.ura-dnav__languages').forEach(form=>form.addEventListener('submit',()=>{const input=form.querySelector('input[name=return_to]');if(input&&location.protocol!=='about:')input.value=location.pathname+location.search+location.hash;}));
 document.querySelectorAll('.ura-dnav__icon').forEach(button=>{
  button.addEventListener('pointermove',event=>{if(!fine.matches||reduced.matches)return;const r=button.getBoundingClientRect(),x=(event.clientX-r.left-r.width/2)*.07,y=(event.clientY-r.top-r.height/2)*.07;button.style.transform=`translate(${x.toFixed(1)}px,${y.toFixed(1)}px)`;});
  button.addEventListener('pointerleave',()=>button.style.removeProperty('transform'));
 });
})();







